<template>
    <div class="about-images-grid-bottom">
        <div class="grid-img" :style="'background-image:url(' + options[0].grid_img + ')'"></div>
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].cards" :key="item.title">
                <div class="item-desc">
                    <h4 v-html="item.title"></h4>
                    <p v-html="item.desc"></p>
                </div>
                <div class="item-img" :style="'background-image:url(' + item.img + ')'"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'about-images-grid-bottom',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/about-images-grid-bottom.scss';
    @import '@/styles/components/about/respond/about-images-grid-bottom-respond.scss';
</style>